import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

const COHORT_OPTIONS = [
    { value: 30, label: 'Últimos 30 días' },
    { value: 60, label: 'Últimos 60 días' },
    { value: 120, label: 'Últimos 120 días' },
    { value: 180, label: 'Últimos 180 días' },
    { value: 365, label: 'Último año' },
];

const STATUS_LABELS = {
    draft: { label: 'BORRADOR', badge: 'badge-secondary' },
    ready: { label: 'LISTO', badge: 'badge-info' },
    sending: { label: 'ENVIANDO', badge: 'badge-warning' },
    completed: { label: 'COMPLETADO', badge: 'badge-success' },
};

const COHORT_LABELS = {
    30: 'Últimos 30 días',
    60: 'Últimos 60 días',
    120: 'Últimos 120 días',
    180: 'Últimos 180 días',
    365: 'Último año',
};

export class Ver_manage_bulk_whatsapp_campaign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaign: null,
            stats: null,
            // Formulario edición
            name: '',
            message_body: '',
            cohort_days: 30,
            // Loading states
            loadingSave: false,
            loadingPrepare: false,
            loadingStart: false,
            loadingStats: false,
            activeTab: 'edit',
        };
        this.handleSave = this.handleSave.bind(this);
        this.handlePrepare = this.handlePrepare.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.loadStats = this.loadStats.bind(this);
    }

    componentWillMount() {
        this.loadCampaign();
    }

    loadCampaign() {
        const { id } = this.props.match.params;
        const user = AuthService.getCurrentUser();
        ApiService.getBulkWhatsappCampaignById(user.token, id).then(
            (res) => {
                if (res && res.status === 'success') {
                    const c = res.data;
                    this.setState({
                        campaign: c,
                        name: c.name,
                        message_body: c.message_body,
                        cohort_days: c.cohort_days,
                    });
                }
            },
            (error) => {
                toast.error('Error al cargar la campaña');
            }
        );
    }

    loadStats() {
        const { id } = this.props.match.params;
        const user = AuthService.getCurrentUser();
        this.setState({ loadingStats: true });
        ApiService.getBulkWhatsappCampaignStats(user.token, id).then(
            (res) => {
                if (res && res.status === 'success') {
                    this.setState({ stats: res.data, loadingStats: false, activeTab: 'stats' });
                } else {
                    this.setState({ loadingStats: false });
                }
            },
            () => { this.setState({ loadingStats: false }); }
        );
    }

    handleSave(e) {
        e.preventDefault();
        const { name, message_body, cohort_days, campaign } = this.state;

        if (!name.trim() || !message_body.trim()) {
            toast.error('Nombre y mensaje son obligatorios');
            return;
        }

        this.setState({ loadingSave: true });
        const user = AuthService.getCurrentUser();

        ApiService.putBulkWhatsappCampaign(user.token, {
            id: campaign.id,
            name: name.trim(),
            message_body: message_body.trim(),
            cohort_days: parseInt(cohort_days),
        }).then(
            (res) => {
                if (res && res.status === 'success') {
                    toast.success('Campaña actualizada');
                    this.setState({ loadingSave: false });
                    this.loadCampaign();
                } else {
                    toast.error((res && res.message) || 'Error al actualizar');
                    this.setState({ loadingSave: false });
                }
            },
            (error) => {
                const msg =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message || error.toString();
                toast.error(msg);
                this.setState({ loadingSave: false });
            }
        );
    }

    handlePrepare() {
        const { campaign } = this.state;
        Swal.fire({
            title: 'Preparar campaña',
            text: 'Se consultará el cohort de clientes y se crearán los registros pendientes. Si ya existen, no se duplicarán. ¿Continuar?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, preparar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                this.setState({ loadingPrepare: true });
                const user = AuthService.getCurrentUser();
                ApiService.prepareBulkWhatsappCampaign(user.token, campaign.id).then(
                    (res) => {
                        if (res && res.status === 'success') {
                            toast.success(
                                `Campaña preparada. ${res.data.total_recipients} destinatarios (${res.data.new_records_created} nuevos)`
                            );
                            this.setState({ loadingPrepare: false });
                            this.loadCampaign();
                        } else {
                            toast.error((res && res.message) || 'Error al preparar');
                            this.setState({ loadingPrepare: false });
                        }
                    },
                    (error) => {
                        const msg =
                            (error.response && error.response.data && error.response.data.message) ||
                            error.message || error.toString();
                        toast.error(msg);
                        this.setState({ loadingPrepare: false });
                    }
                );
            }
        });
    }

    handleStart() {
        const { campaign } = this.state;
        Swal.fire({
            title: '¿Iniciar envío?',
            html: `El cron procesará automáticamente <strong>${campaign.total_recipients}</strong> mensajes en lotes de 50 cada 3 minutos.<br><br>No necesitas hacer nada más. Puedes revisar el progreso en la pestaña <strong>Estadísticas</strong>.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, iniciar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
        }).then((result) => {
            if (result.value) {
                this.setState({ loadingStart: true });
                const user = AuthService.getCurrentUser();
                ApiService.startBulkWhatsappCampaign(user.token, campaign.id).then(
                    (res) => {
                        if (res && res.status === 'success') {
                            toast.success('¡Envío iniciado! El cron procesará los mensajes automáticamente.');
                            this.setState({ loadingStart: false });
                            this.loadCampaign();
                        } else {
                            toast.error((res && res.message) || 'Error al iniciar');
                            this.setState({ loadingStart: false });
                        }
                    },
                    (error) => {
                        const msg =
                            (error.response && error.response.data && error.response.data.message) ||
                            error.message || error.toString();
                        toast.error(msg);
                        this.setState({ loadingStart: false });
                    }
                );
            }
        });
    }

    renderStatusBadge(status) {
        const s = STATUS_LABELS[status] || { label: status, badge: 'badge-secondary' };
        return <span className={`badge ${s.badge}`}>{s.label}</span>;
    }

    renderEditTab() {
        const { name, message_body, cohort_days, campaign, loadingSave } = this.state;
        const isReadOnly = campaign && ['sending', 'completed'].includes(campaign.status);

        return (
            <form onSubmit={this.handleSave}>
                <div className="form-group row">
                    <label className="col-xl-3 col-md-4"><span>*</span> Nombre</label>
                    <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => this.setState({ name: e.target.value })}
                            disabled={isReadOnly}
                            required
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-xl-3 col-md-4"><span>*</span> Cohort</label>
                    <div className="col-md-7">
                        <select
                            className="form-control"
                            value={cohort_days}
                            onChange={(e) => this.setState({ cohort_days: e.target.value })}
                            disabled={isReadOnly}
                        >
                            {COHORT_OPTIONS.map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-xl-3 col-md-4"><span>*</span> Mensaje</label>
                    <div className="col-md-7">
                        <textarea
                            className="form-control"
                            rows="5"
                            value={message_body}
                            onChange={(e) => this.setState({ message_body: e.target.value })}
                            disabled={isReadOnly}
                            required
                        />
                        <small className="form-text text-muted">
                            Usa <code>{'{nombre}'}</code> para personalizar con el nombre del cliente.
                        </small>
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-md-7 offset-xl-3 offset-md-4">
                        <div className="card" style={{ backgroundColor: '#e5ddd5', borderRadius: '8px', padding: '15px' }}>
                            <small className="text-muted mb-2"><strong>Vista previa:</strong></small>
                            <div style={{
                                backgroundColor: 'white', padding: '12px', borderRadius: '8px',
                                whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                            }}>
                                {message_body.replace(/\{nombre\}/gi, 'Juan') || (
                                    <span className="text-muted">El mensaje aparecerá aquí...</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {!isReadOnly && (
                    <div className="pull-right">
                        <button type="submit" className="btn btn-primary" disabled={loadingSave}>
                            {loadingSave && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            Guardar cambios
                        </button>
                    </div>
                )}
                {isReadOnly && (
                    <div className="alert alert-info">
                        Esta campaña ya fue enviada y no puede editarse.
                    </div>
                )}
            </form>
        );
    }

    renderSendTab() {
        const { campaign, loadingPrepare, loadingStart } = this.state;
        if (!campaign) return null;

        const canPrepare = ['draft', 'ready'].includes(campaign.status);
        const canStart = campaign.status === 'ready';
        const isSending = campaign.status === 'sending';
        const isCompleted = campaign.status === 'completed';
        const pendingCount = Math.max(0, campaign.total_recipients - campaign.sent_count - campaign.failed_count);

        return (
            <div>
                {/* Resumen */}
                <div className="row mb-4">
                    <div className="col-md-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <h4 className="text-info">{campaign.total_recipients || 0}</h4>
                                <p className="mb-0 text-muted">Total</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <h4 className="text-warning">{pendingCount}</h4>
                                <p className="mb-0 text-muted">Pendientes</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <h4 className="text-success">{campaign.sent_count || 0}</h4>
                                <p className="mb-0 text-muted">Enviados</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <h4 className="text-danger">{campaign.failed_count || 0}</h4>
                                <p className="mb-0 text-muted">Fallidos</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Paso 1: Preparar */}
                <div className="card mb-3">
                    <div className="card-header d-flex align-items-center">
                        <span className={`badge badge-pill mr-2 ${canPrepare ? 'badge-info' : 'badge-success'}`}>1</span>
                        <h6 className="mb-0">Preparar campaña</h6>
                    </div>
                    <div className="card-body">
                        <p className="text-muted mb-3">
                            Consulta los clientes del cohort <strong>{COHORT_LABELS[campaign.cohort_days]}</strong> y genera los registros de envío.
                            Si ya fue preparada, solo agrega los nuevos clientes.
                        </p>
                        <button
                            className="btn btn-info"
                            onClick={this.handlePrepare}
                            disabled={!canPrepare || loadingPrepare}
                        >
                            {loadingPrepare && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            {canPrepare ? 'Preparar' : '✓ Preparada'}
                        </button>
                    </div>
                </div>

                {/* Paso 2: Iniciar envío automático */}
                <div className="card">
                    <div className="card-header d-flex align-items-center">
                        <span className={`badge badge-pill mr-2 ${isCompleted ? 'badge-success' : 'badge-secondary'}`}>2</span>
                        <h6 className="mb-0">Iniciar envío automático</h6>
                    </div>
                    <div className="card-body">
                        {!isSending && !isCompleted && (
                            <p className="text-muted mb-3">
                                Al iniciar, el servidor enviará los mensajes automáticamente en lotes de 50 cada 3 minutos.
                                No necesitas hacer nada más.
                            </p>
                        )}

                        {isSending && (
                            <div className="alert alert-warning d-flex align-items-center">
                                <span className="spinner-border spinner-border-sm mr-2"></span>
                                <span>
                                    <strong>Enviando...</strong> El cron está procesando los mensajes automáticamente.
                                    Revisa la pestaña <strong>Estadísticas</strong> para ver el progreso.
                                </span>
                            </div>
                        )}

                        {isCompleted && (
                            <div className="alert alert-success">
                                ✓ <strong>Campaña completada.</strong> Todos los mensajes fueron procesados.
                            </div>
                        )}

                        {!isSending && !isCompleted && (
                            <button
                                className="btn btn-success"
                                onClick={this.handleStart}
                                disabled={!canStart || loadingStart}
                            >
                                {loadingStart && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                Iniciar envío
                            </button>
                        )}

                        {!canStart && !isSending && !isCompleted && (
                            <p className="text-muted mt-2 mb-0">
                                <small>Primero debes preparar la campaña (Paso 1).</small>
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    renderStatsTab() {
        const { stats, loadingStats } = this.state;

        if (loadingStats) {
            return <div className="text-center p-4"><span className="spinner-border"></span></div>;
        }

        if (!stats) {
            return (
                <div className="text-center p-4">
                    <button className="btn btn-outline-secondary" onClick={this.loadStats}>
                        Cargar estadísticas
                    </button>
                </div>
            );
        }

        const byStatus = {};
        (stats.stats_by_status || []).forEach((s) => { byStatus[s.status] = s.count; });

        return (
            <div>
                <div className="row mb-4">
                    <div className="col-md-4">
                        <div className="card text-center border-warning">
                            <div className="card-body">
                                <h4 className="text-warning">{byStatus['pending'] || 0}</h4>
                                <p className="mb-0">Pendientes</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card text-center border-success">
                            <div className="card-body">
                                <h4 className="text-success">{byStatus['sent'] || 0}</h4>
                                <p className="mb-0">Enviados</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card text-center border-danger">
                            <div className="card-body">
                                <h4 className="text-danger">{byStatus['failed'] || 0}</h4>
                                <p className="mb-0">Fallidos</p>
                            </div>
                        </div>
                    </div>
                </div>

                {stats.last_failed && stats.last_failed.length > 0 && (
                    <div className="card">
                        <div className="card-header">
                            <h6 className="mb-0">Últimos 10 fallos</h6>
                        </div>
                        <div className="card-body p-0">
                            <table className="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th>Teléfono</th>
                                        <th>Error</th>
                                        <th>Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stats.last_failed.map((f, i) => (
                                        <tr key={i}>
                                            <td>{f.phone}</td>
                                            <td><small className="text-danger">{f.error_message}</small></td>
                                            <td><small>{new Date(f.updated_at).toLocaleString('es-ES')}</small></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                <div className="mt-3">
                    <button className="btn btn-outline-secondary btn-sm" onClick={this.loadStats}>
                        Actualizar
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { campaign, activeTab } = this.state;

        if (!campaign) {
            return (
                <Fragment>
                    <Breadcrumb title="Gestionar Campaña" parent="Promociones" />
                    <div className="container-fluid">
                        <div className="text-center p-5">
                            <span className="spinner-border"></span>
                        </div>
                    </div>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Breadcrumb title="Gestionar Campaña WhatsApp" parent="Promociones" />
                <div className="container-fluid">
                    <div className="card mb-3">
                        <div className="card-body d-flex align-items-center justify-content-between flex-wrap">
                            <div>
                                <h5 className="mb-1">{campaign.name}</h5>
                                <span className="text-muted mr-3">{COHORT_LABELS[campaign.cohort_days]}</span>
                                {this.renderStatusBadge(campaign.status)}
                            </div>
                            <button
                                className="btn btn-light btn-sm"
                                onClick={() => this.props.history.push('/bulk-whatsapp-campaigns')}
                            >
                                ← Volver al listado
                            </button>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <ul className="nav nav-tabs card-header-tabs">
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === 'edit' ? 'active' : ''}`}
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'edit' }); }}
                                    >
                                        Editar
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === 'send' ? 'active' : ''}`}
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); this.setState({ activeTab: 'send' }); }}
                                    >
                                        Preparar y Enviar
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link ${activeTab === 'stats' ? 'active' : ''}`}
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); this.loadStats(); }}
                                    >
                                        Estadísticas
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="card-body">
                            {activeTab === 'edit' && this.renderEditTab()}
                            {activeTab === 'send' && this.renderSendTab()}
                            {activeTab === 'stats' && this.renderStatsTab()}
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        );
    }
}

export default Ver_manage_bulk_whatsapp_campaign;
